import { useState } from 'react';
import styles from './EditScenarioSidebar.module.css';
import { bookIcon, charactersIcon, messagesIcon, globeIcon } from '../../assets/icons';

interface EditScenarioSidebarProps {
  onNavigate: (section: 'details' | 'characters' | 'messages' | 'world') => void;
  onClose: () => void;
}

function EditScenarioSidebar({ onNavigate, onClose }: EditScenarioSidebarProps): JSX.Element {
  const [activeSection, setActiveSection] = useState<'details' | 'characters' | 'messages' | 'world'>('details');

  const handleNavigation = (section: 'details' | 'characters' | 'messages' | 'world') => {
    setActiveSection(section);
    onNavigate(section);
  };

  return (
    <div className={styles.sidebar}>
      <div className={styles.headerContainer}>
        <h2 className={styles.header}>Edit</h2>
        <button 
          className={styles.closeButton}
          onClick={onClose}
          aria-label="Close editor"
        >
          ✕
        </button>
      </div>
      
      <div className={styles.navigation}>
        <button 
          className={`${styles.navButton} ${activeSection === 'details' ? styles.active : ''}`}
          onClick={() => handleNavigation('details')}
        >
          <img src={bookIcon} alt="" className={styles.navIcon} />
          <span>DETAILS</span>
        </button>
        
        <button 
          className={`${styles.navButton} ${activeSection === 'characters' ? styles.active : ''}`}
          onClick={() => handleNavigation('characters')}
        >
          <img src={charactersIcon} alt="" className={styles.navIcon} />
          <span>CHARACTERS</span>
        </button>
        
        <button 
          className={`${styles.navButton} ${activeSection === 'messages' ? styles.active : ''}`}
          onClick={() => handleNavigation('messages')}
        >
          <img src={messagesIcon} alt="" className={styles.navIcon} />
          <span>MESSAGES</span>
        </button>
        
        <button 
          className={`${styles.navButton} ${activeSection === 'world' ? styles.active : ''}`}
          onClick={() => handleNavigation('world')}
        >
          <img src={globeIcon} alt="" className={styles.navIcon} />
          <span>WORLD</span>
        </button>
      </div>
    </div>
  );
}

export default EditScenarioSidebar; 